import { useState } from "react";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const MonthSubmitDialog = ({ label, defaultName, disabled, onConfirm }) => {
  const [declared, setDeclared] = useState(false);
  const [name, setName] = useState(defaultName || "");
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button data-testid="month-final-submit-btn" disabled={disabled} className="gap-2"><Lock className="h-4 w-4" /> Final submission</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Final submission - {label}</AlertDialogTitle>
          <AlertDialogDescription>This locks every day in {label} and sends your hours and invoice number to Accounts.</AlertDialogDescription>
        </AlertDialogHeader>
        <label className="flex items-start gap-3">
          <Checkbox data-testid="month-declaration-checkbox" checked={declared} onCheckedChange={(v) => setDeclared(!!v)} className="mt-0.5" />
          <span className="text-sm text-muted-foreground">I confirm the hours for {label} are a true record of work done and time taken.</span>
        </label>
        <div className="mt-3 space-y-2">
          <Label htmlFor="month-dn">Name (typed)</Label>
          <Input id="month-dn" data-testid="month-declaration-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Type your full name" />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="month-submit-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="month-confirm-submit-btn" disabled={!declared || !name.trim()} onClick={() => onConfirm(name.trim())}>Submit month</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
